// Country code mapping to ReactCountryFlag codes
export const countryFlags = {
  be: 'BE', // Belgium
  nl: 'NL', // Netherlands
  fr: 'FR', // France
  gb: 'GB', // United Kingdom
  de: 'DE', // Germany
  it: 'IT', // Italy
  com: null, // Global/International (no flag, use Globe icon)
};

// Get country code for ReactCountryFlag
export const getCountryFlagCode = (countryCode) => {
  return countryFlags[countryCode?.toLowerCase()] || null;
};

// Get country name (for use with translations)
export const getCountryCode = (countryCode) => {
  return countryCode?.toLowerCase() || 'com';
};

// Check if country code is valid
export const isValidCountryCode = (code) => {
  return countryFlags.hasOwnProperty(code?.toLowerCase());
};

